var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { propMatch } from '@/helpers/custom-prop-types';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiCreateProffitSearchDeviceAssign } from '../../actions/ProffitSearchDeviceAction';
import { apiGetOneProfile } from '../../actions/ProfileActions';
import { wrapDispatch } from '../../helpers/action';
import { compose } from '../../helpers/recompose';
import { useUnmountRef } from '../../helpers/use/useHook';
import Layout from '../Layout';
import { AllLoaderComponent } from '../Ui/Loading';
import ProffitSearchRegistrationDeviceHoc from '../Ui/ProffitSearch/Hoc/ProffitSearchRegistrationDeviceHoc';
import SlideSearchRegistrationDeviceCompleteModal from './RegistrationDevice/Modal/SlideSearchRegistrationDeviceCompleteModal';
const SlideSearchRegistrationDeviceInner = (props) => {
    const { match: { params: { id }, }, } = props;
    const [loading, changeLoading] = useState(true);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const history = useNavigate();
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            changeLoading(true);
            try {
                yield wrapDispatch(dispatch, apiCreateProffitSearchDeviceAssign(id));
                yield wrapDispatch(dispatch, apiGetOneProfile());
            }
            catch (e) {
                if (!unmountRef.current) {
                    history.push('/error/notfound');
                }
            }
            finally {
                if (!unmountRef.current) {
                    changeLoading(false);
                }
            }
        }))();
    }, [history, id, dispatch, changeLoading, unmountRef]);
    return (_jsx(Layout, Object.assign({ isLoading: true, mainClassName: 'l-main' }, { children: loading ? (_jsx(AllLoaderComponent, {})) : (_jsx(SlideSearchRegistrationDeviceCompleteModal, { isShow: true })) })));
};
SlideSearchRegistrationDeviceInner.propTypes = {
    match: propMatch(),
};
const SlideSearchRegistrationDevice = compose(ProffitSearchRegistrationDeviceHoc({ isRegistration: true }))(SlideSearchRegistrationDeviceInner);
export default SlideSearchRegistrationDevice;
